export default {
  fontFamily: `'Lato', sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  // COLORS
  colors: {
    gradientBackground: `linear-gradient(336deg, #004759, #0095a3)`,
    tan: '#eae8e3',
    //
    primary1: '#005364', // darker
    primary2: '#04323f', // darkest
    primary3: '#05B4BE', // light
    primary4: '#00a0af', // lightest
    primary5: '#018793', // medium
    // SUPPORT
    support1: '#00C7D3',
    support2: '#05B4BE',
    // support3: '#ea8d9a',
    // support4: '#dfb1b7',

    // Neutrals
    neutral1: '#1F2933',
    neutral2: '#323F4B',
    neutral3: '#3E4C59',
    neutral4: '#52606D',
    neutral5: '#616E7C',
    neutral6: '#7B8794',
    neutral7: '#9AA5B1',
    neutral8: '#CBD2D9',
    neutral9: '#E4E7EB',
    neutral10: '#F5F7FA',
    // Red
    red1: '#610404',
    red2: '#780A0A',
    red3: '#911111',
    red4: '#A61B1B',
    red5: '#BA2525',
    red6: '#D64545',
    red7: '#E66A6A',
    red8: '#F29B9B',
    red9: '#FACDCD',
    red10: '#FFEEEE',
    // Yellow
    yellow1: '#513C06',
    yellow2: '#7C5E10',
    yellow3: '#A27C1A',
    yellow4: '#C99A2E',
    yellow5: '#E9B949',
    yellow6: '#F7D070',
    yellow7: '#F9DA8B',
    yellow8: '#F8E3A3',
    yellow9: '#FCEFC7',
    yellow10: '#FFFAEB',
  },
};
